<mat-card class="card-password">
  <div class="font-extrabold text-2xl text-center">
    {{ data }}
  </div>
  <div class="flex justify-around items-center mt-5 -mx-2">
    <button mat-flat-button class="btn-tg w-1/12" [mat-dialog-close]="true">
      Sim
    </button>
    <button
      mat-flat-button
      class="btn-tg-cancel w-1/12"
      [mat-dialog-close]="false"
    >
      Não
    </button>
  </div>
</mat-card>
